import React, { useEffect, useRef } from "react"
import { Box } from "@mui/material"
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js"
import { Line } from "react-chartjs-2"
import { TimeScale } from "chart.js"
import "chartjs-adapter-date-fns"

// Registrar los componentes de Chart.js
// Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale)

/*/ Definir los rangos de humedad y sus colores
const humidityRanges = [
  255, 228, 181, 0.3 // Muy seco - beige
  240, 230, 140, 0.3 // Seco - amarillo claro
  173, 216, 230, 0.3 // Normal - azul claro
  135, 206, 250, 0.3 // Húmedo - celeste
  30, 144, 255, 0.3  // Muy húmedo - azul
]*/
const humidityRanges = [
  { min: 0, max: 10, color: "rgba(255, 130, 130, 0.2)" }, // Muy seco - beige
  { min: 10, max: 40, color: "rgba(240, 230, 140, 0.2)" }, // Seco - amarillo claro
  { min: 30, max: 80, color: "rgba(50, 255, 50, 0.2)" }, // Normal - azul claro
  { min: 80, max: 90, color: "rgba(240, 230, 140, 0.2)" }, // Húmedo - celeste
  { min: 90, max: 100, color: "rgba(255, 130, 130, 0.2)" }, // Muy húmedo - azul
]

export function HumidityChart({ data }) {
  const chartRef = useRef(null)

  // Plugin personalizado para dibujar las franjas de colores en el fondo
  const backgroundColorsPlugin = {
    id: "backgroundColors",
    beforeDraw: (chart) => {
      const { ctx, chartArea, scales } = chart
      if (!chartArea) return // Asegurarse de que chartArea esté disponible
      const { top, bottom, left, right } = chartArea
      const yScale = scales.y
  
      if (!yScale) return
  
      humidityRanges.forEach((range) => {
        const yMin = yScale.getPixelForValue(range.max)
        const yMax = yScale.getPixelForValue(range.min)
  
        if (isNaN(yMin) || isNaN(yMax)) return
  
        ctx.save()
        ctx.fillStyle = range.color
        ctx.fillRect(left, yMin, right - left, yMax - yMin)
        ctx.restore()
      })
    },
  }

  const chartData = {
    labels: data.labels.map(t => t * 1000), // Asegúrate que estos sean timestamps válidos
    datasets: [
      {
        label: "Humedad (%)",
        data: data.humidity,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        tension: 0.3,
        pointRadius: 0,
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { left: 0, right: 0, top: 10, bottom: 0 },
    },
    plugins: {
      legend: { position: "top" },
      title: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y}%`,
        },
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        title: {
          display: true,
          text: "Humedad (%)",
        },
      },
      x: {
        type: "time",
        time: {
          unit: "minute",
          tooltipFormat: "dd/MM/yyyy HH:mm",
          displayFormats: {
            minute: "dd/MM/yy HH:mm",
          },
        },
        title: {
          display: true,
          text: "Hora",
        },
      },
    },
  }

  useEffect(() => {
    // Registrar el plugin personalizado
    Chart.register(backgroundColorsPlugin)

    return () => {
      // Limpiar el plugin al desmontar
      Chart.unregister(backgroundColorsPlugin)
    }
  }, [])

  return React.createElement(Box,
    {
      id: "humidity-chart",
      sx: { height: "100%", width: "100%" }
    },
    React.createElement(Line, {
      ref: chartRef,
      data: chartData,
      options: {
        ...chartOptions,
        maintainAspectRatio: false,
        responsive: true,
      },
      style: { width: "100%", height: "100%" }
    })
  )
}
